import SpaceCalculatorPage from './SpaceCalculatorPage';

export default SpaceCalculatorPage;
